export default "__VITE_ASSET__a66ca3df__"